export enum NavigationTypes {
    HORIZONTAL_NAVIGATION = "horizontal_navigation",
    VERTICAL_NAVIGATION = "vertical_navigation"
}

export default NavigationTypes;